// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.niM3Qv7nPgtwmi {
  gap: var(--ds-space-150, 12px);
  padding: var(--ds-space-025, 2px);
  padding-bottom: var(--ds-space-100, 8px);
  flex-direction: column;
  display: flex;
}
`, ""]);
// Exports
export var popoverContent = `niM3Qv7nPgtwmi`;
export default ___CSS_LOADER_EXPORT___;
